import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=e3565ce0&"
import script from "./Carousel.vue?vue&type=script&lang=js&"
export * from "./Carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/ensign-boligprosjekter/app/public/wp-content/plugins/ensign-boligprosjekter/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3565ce0')) {
      api.createRecord('e3565ce0', component.options)
    } else {
      api.reload('e3565ce0', component.options)
    }
    module.hot.accept("./Carousel.vue?vue&type=template&id=e3565ce0&", function () {
      api.rerender('e3565ce0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Carousel.vue"
export default component.exports